import { LegalDocument } from '../../components/legal/LegalDocument';
import { termsIosContent } from '../../content/legal/termsIosContent';

export function IosTerms() {
  return (
    <LegalDocument
      content={termsIosContent}
      platform="ios"
      seoDescription="LuvLust iOS Terms and Conditions. Subscription terms for the couples app."
      seoKeywords="luvlust ios terms, subscription terms, app store terms"
    />
  );
}
